export const setMeta = (meta) => {
  const titleTemplate =
    "titleTemplate" in meta
      ? meta.titleTemplate || ""
      : " | au PAY スマートローン";
  document.title = meta.title + titleTemplate;
  document
    .querySelector('meta[name="description"]')
    .setAttribute("content", meta?.description);
  document
    .querySelector('meta[name="keywords"]')
    .setAttribute("content", meta?.keywords);
};
